import { StorageItem } from "@/Features/Storage/storage.types";
import styled from "styled-components";

interface StorageItemData extends StorageItem {
  storage_number?: string;
  make?: string;
  model_name?: string;
  serial_number?: string;
  is_general_storage?: number;
}

const StorageSelectBoxItem = ({
  className,
  data,
}: {
  className?: string;
  data: StorageItemData;
}) => {
  return (
    <div className={className}>
      <StyledStorageNumber>{data?.storage_number}</StyledStorageNumber>
      <StyledStorageInfo>
        <div>
          {data?.make || "Unknown"} {data?.model_name || "Unknown"}
        </div>
        <div>S/N: {data?.serial_number || "None"}</div>
      </StyledStorageInfo>
    </div>
  );
};

const StyledStorageNumber = styled.div`
  margin-bottom: 5px;
`;

const StyledStorageInfo = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 11px;
`;

export default StorageSelectBoxItem;
